export default function ({ route, redirect }) {
  // Check if the URL ends with a '/'
  if (route.fullPath.endsWith("/") && route.fullPath !== "/") {
    // Remove the trailing '/'
    const newUrl = route.fullPath.slice(0, -1);
    // Redirect the user to the new URL
    return redirect(newUrl);
  }
}
